import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const AppCircularProgress = ({ className, size = 40 }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress className={className} size={size} />
    </div>
  );
};

export default AppCircularProgress;
